import { Link, Outlet, useLocation } from "react-router-dom";
import BasicLayout from "../../layout/BasicLayout";
import useCustomLogin from "../../hooks/useCustomLogin";
import ProfileComponent from "../../components/my/ProfileComponent";

/**
 * /my 내의 경로에 대한 레이아웃 역할
 */
const IndexPage = () => {
  //   const location = useLocation();
  //   const pageName = location.pathname.substring(
  //     location.pathname.lastIndexOf("/") + 1
  //   );

  const { isLogin, moveToLoginReturn } = useCustomLogin();

  if (!isLogin) {
    return moveToLoginReturn();
  }

  return (
    <BasicLayout pageClassName="profile bg-map">
      <div className="content profile-content">
        <div className="list-st rc-list">
          <ul className="tabs mypage-tabs">
            <li className="on">
              <Link to="../profile">프로필</Link>
            </li>
            <li>
              <Link to="../record">게임 기록</Link>
            </li>
            <li>
              <Link to="../history">구매 내역</Link>
            </li>
          </ul>
          <ProfileComponent />
        </div>
      </div>
    </BasicLayout>
  );
};

export default IndexPage;
